// import Axios from "axios";

// const baseURL = "https://scorerapi-production.up.railway.app";
// // const baseURL = "http://localhost:5000";

// const axios = Axios.create({
//   baseURL,
//   headers: { "Content-Type": "application/json" },
//   credentials: "include",
// });

// export const fetcher = (url) => {
//   return handleRequest("get", url);
// }

// export const getFetcher = (url, body) => {
//   return handleRequest("get", url, body);
// }

// export const postFetcher = (url, body) => {
//   return handleRequest("post", url, body);
// };

// const handleRequest = async (method, url, body) => {
//   try {
//     const res = await axios.request({
//       method,
//       url,
//       data: method === "get" ? {} : body?.arg,
//       params: method === "get" ? body?.arg : {},
//       headers: { "Content-Type": "application/json" },
//     });

//     return res.data;
//   } catch (error) {
//     let message = "Something went wrong";

//     if (Axios.isAxiosError(error)) {
//       const axiosError = error;
//       message = axiosError.response?.data?.message || axiosError.message;
//       throw new Error(JSON.stringify({ ...(axiosError.response?.data || {}) }));
//     }

//     throw new Error(message);
//   }
// };






import Axios from "axios"

const baseURL = "https://scorerapi-production.up.railway.app"
// const baseURL = "http://localhost:5000";


const axios = Axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
})

export const fetcher = (url) => {
  return handleRequest("get", url)
}

export const getFetcher = (url, body) => {
  return handleRequest("get", url, body)
}

export const postFetcher = (url, body) => {
  return handleRequest("post", url, body)
}

const handleRequest = async (method, url, body) => {
  try {
    const res = await axios.request({
      method,
      url,
      data: method === "get" ? {} : body?.arg,
      params: method === "get" ? body?.arg : {},
      headers: { "Content-Type": "application/json" },
    })

    return res.data
  } catch (error) {
    if (Axios.isAxiosError(error)) {
      const axiosError = error
      const responseData = axiosError.response?.data

      // If it's a 400 error (like "No quotes available"), return the response data
      // instead of throwing an error. This allows the UI to handle it gracefully.
      if (axiosError.response?.status === 400 && responseData) {
        return responseData
      }

      // For other errors, throw as usual
      const message = responseData?.message || axiosError.message
      throw new Error(JSON.stringify({ ...(responseData || {}) }))
    }

    throw new Error("Something went wrong")
  }
}
